module.exports = __webpack_public_path__ + "static/what_should_i_do_tonight-d21da5c84b04ccc111559afbe248ddec.png";